import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { format } from "date-fns";
import { Fragment } from "react";

import { MemoizedLabStain } from "shared/selectors/selectLabStains";

import "./LabStainSuggestion.css";

const getCutOffTime = (cutOffTime: string) => {
  const [hour, minute, second] = cutOffTime.split(":").map((s) => parseInt(s));
  const currDate = new Date().setUTCHours(hour, minute, second);

  return format(currDate, "h:mm a");
};

export const HighlightedSuggestion = ({
  haystack,
  needle,
}: {
  haystack: string;
  needle: string;
}) => {
  const chunks: { text: string; highlight: boolean }[] = parse(
    haystack,
    match(haystack, needle, { insideWords: true })
  );

  return (
    <>
      {chunks.map((chunk, i) => {
        const { highlight, text } = chunk;
        return highlight ? (
          <span className="suggestion__block__highlighted" key={i}>
            {text}
          </span>
        ) : (
          <Fragment key={i}>{text}</Fragment>
        );
      })}
    </>
  );
};

const LabStainSuggestion = ({
  labstain,
  query,
}: {
  labstain: MemoizedLabStain;
  query?: string;
}) => {
  return (
    <div className="LabStainSuggestion">
      <div className="suggestion__block suggestion__block--header">
        <span>
          <strong>
            <HighlightedSuggestion
              haystack={labstain.stain?.abbreviation || ""}
              needle={query || ""}
            />
          </strong>{" "}
          (
          <HighlightedSuggestion
            haystack={labstain.stain?.name || ""}
            needle={query || ""}
          />
          )
        </span>
        {labstain.external_stain && (
          <span>
            {labstain.external_stain?.external_lab?.name}
            {!labstain.external_stain?.external_lab?.name?.includes(
              "Sendout"
            ) && <> Sendout</>}
          </span>
        )}
      </div>
      <div className="suggestion__block suggestion__block--light">
        {labstain.cutoff_time && (
          <span>
            <strong>Cutoff:</strong> {getCutOffTime(labstain.cutoff_time)}
          </span>
        )}
        {labstain.turnaround_hours && (
          <span>
            <strong>Turn Around:</strong> {labstain.turnaround_hours} hours
          </span>
        )}
      </div>
    </div>
  );
};

export default LabStainSuggestion;
